export default {
    Myself: 'myself',
    Others: 'others',
    Team: 'team',
    Club: 'club',
}